import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import { Sponsors, SponsorDetail } from "@/pages/Sponsors";
import Dashboard from "@/pages/Dashboard";
import Employer from "@/pages/Employer";
import Admin from "@/pages/Admin";
import VisaWorkspace, { VisaDetail } from "@/pages/VisaSupport";
import Verification from "@/pages/Verification";
import Consultations from "@/pages/Consultations";
import { Visas, Study, Academy, News, Partners, WhiteLabel } from "@/pages/Portals";
import { Programmes, InnovatorFounderProgramme } from "@/pages/Programmes";
import CvBuilder from "@/pages/CvBuilder";
import { PaymentSuccess, PaymentCancel, CvMarketing } from "@/pages/Payments";
import CommunicationHub from "@/pages/CommunicationHub";
import CommunicationOperations from "@/pages/CommunicationOperations";
import AIApplications from "@/pages/AIApplications";
import StudyWorkspace from "@/pages/StudyWorkspace";
import StudyCourseDetail from "@/pages/StudyCourseDetail";
import SavedJobs from "@/pages/SavedJobs";
import ProtectedRoute from "@/components/ProtectedRoute";
import Legal from "@/pages/Legal";
import ReportValidate from "@/pages/ReportValidate";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/sponsorship-jobs" element={<Jobs sponsorshipMode />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/sponsors/:id" element={<SponsorDetail />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/ai-applications" element={<ProtectedRoute><AIApplications /></ProtectedRoute>} />
            <Route path="/jobs/saved" element={<ProtectedRoute><SavedJobs /></ProtectedRoute>} />
            <Route path="/study/workspace" element={<StudyWorkspace />} />
            <Route path="/study/course/:courseId" element={<StudyCourseDetail />} />
            <Route path="/employer" element={<ProtectedRoute roles={["employer", "recruiter", "employer_team_member"]}><Employer /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["super_admin", "tenant_admin", "tenant_owner", "compliance_reviewer", "support_staff", "content_editor", "finance_admin"]}><Admin /></ProtectedRoute>} />
            <Route path="/communications/whatsapp" element={<ProtectedRoute roles={["super_admin", "tenant_admin", "tenant_owner", "support_staff", "recruiter", "compliance_reviewer"]}><CommunicationHub /></ProtectedRoute>} />
            <Route path="/communications/whatsapp/operations" element={<ProtectedRoute roles={["super_admin", "tenant_admin", "tenant_owner", "support_staff", "recruiter", "compliance_reviewer"]}><CommunicationOperations /></ProtectedRoute>} />
            <Route path="/verify" element={<Verification />} />
            <Route path="/verify/validate" element={<ReportValidate />} />
            <Route path="/consultations" element={<Consultations />} />
            <Route path="/visas" element={<Visas />} />
            <Route path="/visas/:slug" element={<VisaDetail />} />
            <Route path="/visa-support" element={<ProtectedRoute><VisaWorkspace /></ProtectedRoute>} />
            <Route path="/programmes" element={<Programmes />} />
            <Route path="/programmes/innovator-founder" element={<InnovatorFounderProgramme />} />
            <Route path="/study" element={<Study />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/news" element={<News />} />
            <Route path="/partners" element={<ProtectedRoute><Partners /></ProtectedRoute>} />
            <Route path="/cv-builder" element={<ProtectedRoute><CvBuilder /></ProtectedRoute>} />
            <Route path="/white-label" element={<WhiteLabel />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/cv-marketing" element={<CvMarketing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}
export default App;

